import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    frameServicesBorder: {
        borderBottom: '2px solid #BBBBBA',
        paddingBottom: '24px',
        marginBottom: '24px'
    },
    frameServices: {
        paddingBottom: '24px',
        marginBottom: '24px'
    },
    subtitleFrame: {
        fontFamily: 'MontserratSemiBold',
        color: theme.palette.opinions.service,
        fontSize: '30px',
        lineHeight: '160%',
        letterSpacing: '0px',
        textAlign: 'left',
        fontStyle: 'passthrough',
       // textTransform: 'capitalize',
    },
    bodyFrame: {
        fontFamily: 'MontserratLight',
        lineHeight: '160%',
        letterSpacing: '0px',
        color: theme.palette.opinions.service,
        fontSize: '20px',
        textAlign: 'left',
        fontStyle: 'passthrough',

        // textTransform: 'capitalize',
    },
    iconFrame: {
        display: 'flex',
        justifyContent: 'flex-start'
    },
    imgFrame: {
        // width: '47.7px',
        // height: '42.17px'
        // width: '48.7px',
        // height: '43.17px'
        width: '50.7px',
        height: '47.17px'

    },
    articleFrame: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start'


    }
}));

export default useStyles;
